export const GetLayoutSectionMixin = {
  props: {
    id: {type: String}
  },

  computed: {
    _infos () {
      return this.$store.getters['infos']
    }
  },

  watch: {
    'settings.title': {
      deep: true,
      handler (v) {
        if (this.settingsTitle) {
          this.settingsTitle.title = v
        }
      }
    },

    'settings.subtitle': {
      deep: true,
      handler (v) {
        if (this.settingsTitle) {
          this.settingsTitle.subtitle = v
        }
      }
    }    
  },

  methods: {
    // type: image, color or video
    MIXIN_getBgInfo (section, type) {
      if (section.idLayout) {
        const layout = this._infos.layout.find(layout => layout.id === section.idLayout)
        if (!layout) return ''

        const bgType = layout.bg['background-type']
        if (bgType === type) return layout.bg[`background-${type}`]
        else return ''
      }

      if (!section.idLayout) {
        const bgType = section.bg['background-type']
        if (bgType === type) return section.bg[`background-${type}`]
        else return ''
      }
    },

    MIXIN_isVideoBg (section) {
      if (section.idLayout) {
        const layout = this._infos.layout.find(layout => layout.id === section.idLayout)
        if (!layout) return ''

        const bgType = layout.bg['background-type']
        return bgType === 'video' && layout.bg[`background-video`]
      }

      if (!section.idLayout) {
        const bgType = section.bg['background-type']
        return bgType === 'video' && section.bg['background-video']
      }
    },  

    /*
      category: 'title' | 'subtitle' | 'text' | 'button'
      type: 'color' | 'font' | 'font-size' | 'font-style' | 'weight' // default types

      ** button category, have types: 'color', 'background-color', 'border-radius'
     */
    MIXIN_getStyle (section, category, type, specificBtn = 0) {
      if (section.idLayout) {
        const layout = this._infos.layout.find(layout => layout.id === section.idLayout)
        if (layout && layout[category][type]) return layout[category][type]
        else return ''
      }

      if (!section.idLayout) {
        if (category !== 'button') {
          let value = section[category][type]
          return value || this._infos.layout[0][category][type]
        }

        if (category === 'button') {
          const value = section.buttons[specificBtn][type]
          const defaultStyle = this._infos.layout[0]['button'][type]

          return value || defaultStyle
        }
      }
    }      
  }
}